/**
 * Takes a string and converts it to a data URL
 */
export function getImageDataURL(svg: string, maxSvgHeight: number, maxSvgWidth: number): string | undefined {
    if (!svg) return;
    const resizedSvg = resizeSvg(svg, maxSvgHeight, maxSvgWidth);
    return 'data:image/svg+xml;base64,' + btoa(resizedSvg);
}

function resizeSvg(svg: string, maxHeight: number, maxWidth: number): string {
    const parser = new DOMParser();
    const originalSvg = parser.parseFromString(svg, 'image/svg+xml');
    const originalWidth = parseFloat(originalSvg.documentElement.getAttribute('width') ?? '0');
    const originalHeight = parseFloat(originalSvg.documentElement.getAttribute('height') ?? '0');

    let newWidth: number;
    let newHeight: number;

    if (originalWidth / maxWidth > originalHeight / maxHeight) {
        newWidth = maxWidth;
        newHeight = originalHeight / originalWidth * maxWidth;
    } else {
        newHeight = maxHeight;
        newWidth = originalWidth / originalHeight * maxHeight;
    }

    if (newHeight > maxHeight) {
        newHeight = maxHeight;
        newWidth = originalWidth / originalHeight * maxHeight;
    }

    originalSvg.documentElement.setAttribute('width', String(newWidth));
    originalSvg.documentElement.setAttribute('height', String(newHeight));

    return new XMLSerializer().serializeToString(originalSvg);
}
